import { Award, Star, ShieldCheck, Landmark } from "lucide-react";

// Central mapping used by every Trust Network surface. Kept small so it stays
// asset-agnostic across future modules (Property, Equipment, Business, Fleet).

export const TIER_STYLE = {
  bronze:     { label: "Bronze",     ring: "#a97142", bg: "bg-[#a97142]/12",   text: "text-[#a97142]",   border: "border-[#a97142]/40" },
  silver:     { label: "Silver",     ring: "#8f95a3", bg: "bg-slate-500/10",   text: "text-slate-600",   border: "border-slate-400/60" },
  gold:       { label: "Gold",       ring: "#D4AF37", bg: "bg-amber-500/10",   text: "text-amber-700",   border: "border-amber-500/50" },
  platinum:   { label: "Platinum",   ring: "#7B90A8", bg: "bg-teal-600/10",    text: "text-teal-700",    border: "border-teal-500/50" },
  government: { label: "Government", ring: "#0F3B2F", bg: "bg-emerald-800/10", text: "text-emerald-900", border: "border-emerald-800/50" },
};

export const CATEGORY_LABEL = {
  dealership: "Dealership",
  bank: "Bank",
  insurance: "Insurance",
  workshop: "Workshop",
  tyre_centre: "Tyre Centre",
  inspection_station: "Inspection Station",
  government: "Government Agency",
  fleet_operator: "Fleet Operator",
  logistics: "Logistics",
  auction_house: "Auction House",
  law_firm: "Law Firm",
};

export const TierBadge = ({ tier, size = "sm" }) => {
  const s = TIER_STYLE[tier] || TIER_STYLE.bronze;
  const pad = size === "lg" ? "px-3 py-1.5 text-xs" : "px-2 py-0.5 text-[10px]";
  return (
    <span
      data-testid={`tier-badge-${tier}`}
      className={`inline-flex items-center gap-1.5 ${pad} mono uppercase tracking-widest font-semibold rounded-sm border ${s.bg} ${s.text} ${s.border}`}
    >
      {tier === "government" ? <Landmark className="h-3 w-3" /> : <Award className="h-3 w-3" />}
      {s.label}
    </span>
  );
};

export const ReputationBadge = ({ rep, size = "sm" }) => {
  if (!rep) return null;
  const band = rep.band || "New";
  const bg =
    band === "Elite" ? "bg-emerald-700 text-white" :
    band === "Trusted" ? "bg-emerald-100 text-emerald-800 border border-emerald-300" :
    band === "Established" ? "bg-amber-100 text-amber-800 border border-amber-300" :
    band === "Emerging" ? "bg-sky-100 text-sky-800 border border-sky-300" :
    "bg-slate-100 text-slate-600 border border-slate-300";
  const pad = size === "lg" ? "px-3 py-1.5 text-xs" : "px-2 py-0.5 text-[10px]";
  return (
    <span className={`inline-flex items-center gap-1.5 ${pad} mono uppercase tracking-widest font-semibold rounded-sm ${bg}`}>
      <Star className="h-3 w-3" /> {band} · {rep.score}
    </span>
  );
};

export const VerifiedPill = ({ status }) => {
  if (status === "verified") return (
    <span className="inline-flex items-center gap-1.5 px-2 py-0.5 text-[10px] mono uppercase tracking-widest font-semibold rounded-sm bg-primary text-primary-foreground">
      <ShieldCheck className="h-3 w-3" /> Verified
    </span>
  );
  if (status === "pending") return <span className="mono text-[10px] uppercase tracking-widest text-amber-700 border border-amber-400/50 bg-amber-50 px-2 py-0.5 rounded-sm">Pending Review</span>;
  return <span className="mono text-[10px] uppercase tracking-widest text-muted-foreground border px-2 py-0.5 rounded-sm">{status}</span>;
};
